import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";
import { ModalStore } from "@/hooks/Modal/ModalStore";
import GlobalStore from "@/store";
import CreateDecryptedManualOrderModal from ".";
import { Modal } from "antd";
import Authority from "@/enum/Authority";

export function openCreateDecryptedManualOrderModal(
    globalStore: typeof GlobalStore,
    modalStore: ModalStore,
    order: OrderDTO,
    eventContext?: string,
) {
    const shop = globalStore.shopMapping.get(order.shopId);

    const pass = globalStore.checkUserAuthority(Authority.ROLE_ORDER_PRIVACY_CONSIGNEE_DECRYPT);

    if (!pass) return;

    modalStore.openModal(CreateDecryptedManualOrderModal, { order, eventContext });
}
